import StepRoute from '../classes/step-route.class';
import RouteNames from '../constants/route-names';
import RouteGuards from './appointment-signin.guards';

const route = new StepRoute(
  RouteNames.AppointmentSignIn,
  'sign-in',
  () => import('@/views/steps/SigninStep.vue'),
);

route.isAccountManagementStep();
route.requiresScheduleStep();
route.requiresPropertyStep();
route.showSummarySidebar();

route.navigationGuard((to, from, next) => {
  const backButtonRedirectRoute = RouteGuards.backButtonNavigation(from);
  if (backButtonRedirectRoute) {
    next({ name: backButtonRedirectRoute, params: to.params });
  } else {
    next();
  }
});

export default route.getRoute();
